import React from 'react'
import { Row, Col, Button } from 'react-bootstrap'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import Input from '_/shared/components/input'
import createLinkToImmutable from '_/utils/createLinkToImmutable'
import getGravatarUrl from '_/utils/getGravatarUrl'
import CreditCard from '_/shared/components/creditCard'
import ConfirmModal from '_/shared/components/confirmModal'

const autoshareType = {
  all: [
    { label: 'Sales', value: 'Sale' },
    { label: 'Leases', value: 'Lease' },
    { label: 'Income & expenses', value: 'IncExp' },
    { label: 'Construction costs', value: 'Const' },
    { label: 'Properties', value: 'Property' }
  ],
  ag: [
    { label: 'Sales', value: 'Sale' },
    { label: 'Income & expenses', value: 'IncExp' },
    { label: 'Properties', value: 'Property' }
  ],
  sfr: [
    { label: 'Sales', value: 'Sale' },
    { label: 'Properties', value: 'Property' }
  ]
}

/**
 * Group settings
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class GroupSettings extends React.Component {
  static contextTypes = {
    store: React.PropTypes.object,
    router: React.PropTypes.func,
    notify: React.PropTypes.func
  }

  static propTypes = {
    account: React.PropTypes.object.isRequired,
    stripeCustomer: React.PropTypes.object
  }

  static fetchData (store, params) {
    return {
      stripeCustomer: store.get('/account/stripe')
    }
  }

  constructor (props, context) {
    super(props, context)
    this.state = {
      group: props.account.get('group')
    }
  }

  confirmDestroy (evt) {
    evt.preventDefault()
    this.setState({ showConfirmModal: true })
  }

  cancelDestroy () {
    this.setState({ showConfirmModal: false })
  }

  async destroy (evt) {
    const { store, notify } = this.context
    const { account } = this.props
    try {
      await store.deactivate(account)
    } catch (er) {
      console.error(er)
      notify(er.response.body.error)
    }
  }

  async updateGroup (evt) {
    evt.preventDefault()
    const { store, router } = this.context
    const { group } = this.state

    try {
      await store.post('/account', { group })
      router.transitionTo('dashboard')
    } catch (er) {
      this.setState({
        errors: er.response.body.details
      })
    }
  }

  render() {
    const { group, showConfirmModal } = this.state
    const { stripeCustomer } = this.context.store.data
    const hasStripe = stripeCustomer && !stripeCustomer.isEmpty()
    const autoshareOpts =
      (group.get('isSfr') && autoshareType.sfr) ||
      (group.get('isAg') && autoshareType.ag) ||
      autoshareType.all

    const photo = getGravatarUrl(group.get('logoEmail'), 600)
    const ln = createLinkToImmutable(this, 'group')

    return (
      <div>
        <form onSubmit={::this.updateGroup}>
          <Row>
            <Col xs={6}>
              <Input
                type="text"
                valueLink={ln('name')}
                name="name"
                errors={this.state.errors}
                label="Group/company name" />
              <Input
                multi
                type="select"
                valueLink={ln('autoShare')}
                name="autoShare"
                options={autoshareOpts}
                errors={this.state.errors}
                label="Autoshare old records of type" />
              <Input
                type="text"
                valueLink={ln('logoEmail')}
                name="logoEmail"
                help="This is logo is used for reporting"
                errors={this.state.errors}
                label="Company logo email" />
              {hasStripe && <CreditCard stripeCustomer={stripeCustomer} />}
              {hasStripe && <Input
                type="text"
                valueLink={ln('stripeEm')}
                name="stripeEm"
                help="Invoices will be sent to this address"
                errors={this.state.errors}
                label="Billing email address" />}
              <p>
                <Button
                  type="submit"
                  bsStyle="primary">
                  Save changes
                </Button>
              </p>
            </Col>
            <Col xs={6}>
              <p className="text-center text-muted">
                <img className="img-circle" src={photo} style={{ width: 300 }}/>
                <br/><br/>
                Profile pictures are generated using the company email address from gravatar.com.  Update your picture <a href="http://en.gravatar.com/emails/">here</a>.
              </p>
              {hasStripe &&
                <p className="text-center">
                  <br/><br/>
                  <a href="" className="text-danger" onClick={::this.confirmDestroy}>
                    Deactivate this account
                  </a>
                </p>
              }
            </Col>
          </Row>
        </form>

        {showConfirmModal &&
          <ConfirmModal
            actionText="Yes, deactivate my account"
            onAction={::this.destroy}
            onCancel={::this.cancelDestroy}
            bsStyle="danger"
            message={
              <div>
                <p><b className="text-danger">Warning!  Destructive operation!</b></p>
                <p>Deactivating your account will stop your subscription to REDIComps and disassociate <i>all</i> members.</p>
                <p><b>Are you sure you want to deactivate this account?</b></p>
              </div>
            }
          />
        }
      </div>
    )
  }
}

export default GroupSettings



// WEBPACK FOOTER //
// ./modules/shared/pages/account/groupSettings.js